import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '../environment/environment.service';

export class Organization {
  organizationId: number;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(
    private httpClient: HttpClient,
    private environmentService: EnvironmentService) {}

  async getOrganizations(companyId: number): Promise<Organization[]> {
    const requestUrl = `${this.environmentService.activeAppBaseUrl}/api/organizations/` + companyId.toString();
    const headers: HttpHeaders = new  HttpHeaders( {'content-type': 'application/json'});
    const result = this.httpClient.get<Organization[]>(requestUrl, { headers}).toPromise();

    return result;
  }
}
